"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[327],{

/***/ 4803:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/close-icon.76e4372f.svg","height":16,"width":16});

/***/ }),

/***/ 5003:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/wa-icon.fe5c3393.png","height":80,"width":80,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAASFBMVEX///9ibV8MHwY7STdoc2U6SjZMaXE3RDNZZVbY29arsqiTm5EPHwoQIQsOHAdXY1QHFwDP08/d4dyfpp16hHfh5eG3vLbi5uHk0yPKAAAAEXRSTlP+6ii79awAmuL+/PkwLiT+ITanZpQAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAA8SURBVHicBcGFAYAwEACxq7wVrQD7b0qCZqm1HEr2B760Y7F1GELieoGK09ecJKwTq4VgLWD4STFzt1t/RAIB/V8AHdcAAAAASUVORK5CYII="});

/***/ }),

/***/ 7983:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/wa-svg-icon.bf0ceb42.svg","height":211,"width":211});

/***/ }),

/***/ 5060:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/workay-logo.a70ff81a.svg","height":60,"width":60});

/***/ }),

/***/ 2601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Footer_Footer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./assets/images/footer-border.png
/* harmony default export */ var footer_border = ({"src":"/_next/static/media/footer-border.a312f1ad.png","height":60,"width":5760,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAMAAADU3h9xAAAABlBMVEX///////9VfPVsAAAAAnRSTlNeTVrGgM8AAAAJcEhZcwAALEsAACxLAaU9lqkAAAAMSURBVHicY2BkgAAAABEAAvIZoJkAAAAASUVORK5CYII="});
// EXTERNAL MODULE: ./assets/logo/workay-logo.svg
var workay_logo = __webpack_require__(5060);
// EXTERNAL MODULE: ./assets/icons/wa-icon.png
var wa_icon = __webpack_require__(5003);
;// CONCATENATED MODULE: ./assets/icons/mail-icon.png
/* harmony default export */ var mail_icon = ({"src":"/_next/static/media/mail-icon.8a7034e9.png","height":50,"width":66,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAG1BMVEU5SDU5RzQ2RDM5SDQ4RjQ3QzQ4RzU4RjU5RTGDZeZUAAAACXRSTlP+z13lvWbb6j6Ya2wSAAAACXBIWXMAABYlAAAWJQFJUiTwAAAALElEQVR4nCXKwQ0AIAzDQCdpC/tPjICfdTIWQG3GAXWBTJy53C3ekAXzE+oACocAWxCejVsAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./assets/icons/kominfo-icon.svg
/* harmony default export */ var kominfo_icon = ({"src":"/_next/static/media/kominfo-icon.4e23a8b1.svg","height":60,"width":60});
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/Footer/Footer.js








var Footer = function(param) {
    var openModal = param.openModal;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
        className: "relative",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "md:h-[362px] w-full bg-w-green-100 flex flex-col overflow-hidden",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-[1700px] md:w-full overflow-hidden",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        layout: "responsive",
                        src: footer_border,
                        alt: "_footer-border"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container mx-auto flex px-[38px] pt-[40px] md:pt-0 h-full flex-col md:flex-row md:justify-between md:items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "h-[60px] w-[60px]",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            layout: "fixed",
                                            src: workay_logo/* default */.Z,
                                            alt: "_logo"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "md:w-[253px] mt-[35px] md:mt-[16px] md:text-left",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Workay adalah platform kesehatan finansial untuk karyawan dan membantu perusahaan mempertahankan pekerja terbaik."
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col mt-[65px] md:mt-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "font-bold",
                                        children: "Hubungi Kami di :"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-row gap-x-[16px] mt-[14px]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            onClick: openModal,
                                            className: "h-[30px] w-[30px] transition-all hover:scale-110 active:scale-100",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                layout: "responsive",
                                                src: wa_icon/* default */.Z,
                                                alt: "_logowa"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "transition-all h-[30px] w-[35px] hover:scale-110 active:scale-100",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "mailto:cs@workay.id",
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    layout: "responsive",
                                                    src: mail_icon,
                                                    alt: "_logomail"
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mt-[65px] mb-[40px] md:mb-[0px] md:mt-0 flex flex-col md:items-end",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col md:flex-row md:items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "h-[60px] w-[60px]",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                layout: "fixed",
                                                src: kominfo_icon,
                                                alt: "_logo"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "w-[200px] text-[12px] mt-[10px] md:mt-0 md:ml-[12px]",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "whitespace-pre-line",
                                                children: "Nomor TDPSE: 001852.02/DJAI.PSE/08/2022"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "hidden md:flex w-full text-[14px] justify-center flex-row items-center gap-x-[10px] md:gap-x-[20px] text-w-green-200 font-bold mt-[50px] md:mt-[20px]",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/privacy",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "cursor-pointer hover:scale-105 active:scale-100",
                                                children: "Kebijakan dan privasi"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "h-[15px] w-[1px] bg-w-green-200"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/term",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "cursor-pointer hover:scale-105 active:scale-100",
                                                children: "Syarat dan ketentuan"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex absolute w-full md:hidden text-[14px] bottom-[50px] left-[50%] -translate-x-[50%] justify-center flex-row items-center gap-x-[10px] md:gap-x-[20px] text-w-green-200 font-bold mt-[50px] md:mt-[20px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/privacy",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "cursor-pointer hover:scale-105 active:scale-100",
                                children: "Kebijakan dan privasi"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "h-[15px] w-[1px] bg-w-green-200"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/term",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "cursor-pointer hover:scale-105 active:scale-100",
                                children: "Syarat dan ketentuan"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-screen h-[32px] bg-w-green-200 mt-[50px] md:mt-0"
                })
            ]
        })
    });
};
/* harmony default export */ var Footer_Footer = (Footer);


/***/ }),

/***/ 7978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Navbar_Navbar; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./assets/logo/workay-logo.svg
var workay_logo = __webpack_require__(5060);
;// CONCATENATED MODULE: ./assets/icons/burger-icon.svg
/* harmony default export */ var burger_icon = ({"src":"/_next/static/media/burger-icon.92d28dab.svg","height":20,"width":30});
// EXTERNAL MODULE: ./assets/icons/close-icon.svg
var close_icon = __webpack_require__(4803);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(6261);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 4 modules
var transition = __webpack_require__(4080);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/dialog/dialog.js + 24 modules
var dialog = __webpack_require__(787);
;// CONCATENATED MODULE: ./assets/icons/icon-png-ps-32.png
/* harmony default export */ var icon_png_ps_32 = ({"src":"/_next/static/media/icon-png-ps-32.c2d943ef.png","height":128,"width":413,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAGFBMVEUYIR4qMjAZGRk+QD1RUVEFBQUmJCUqKioDSKMMAAAACHRSTlP78/329Ob83yQGmdUAAAAJcEhZcwAALEsAACxLAaU9lqkAAAAaSURBVHicY2BgYGNgYmJiZWBkZmRmYWRmBwABOAApHnP5FwAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./assets/icons/icon-png-ps-42.png
/* harmony default export */ var icon_png_ps_42 = ({"src":"/_next/static/media/icon-png-ps-42.215cafe3.png","height":168,"width":496,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAGFBMVEUBAQE4ODkICgoAAAATExQFBAQ4UEU0Ly2vKeffAAAAAXRSTlPg4Ow6HgAAAAlwSFlzAAAsSwAALEsBpT2WqQAAAB9JREFUeJwFwYEBACAAgjBEq/8/boPqacH7kqQwN8cHA0IAPb5dw1AAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./assets/icons/icon-ps.svg
/* harmony default export */ var icon_ps = ({"src":"/_next/static/media/icon-ps.c514c97f.svg","height":32,"width":104});
;// CONCATENATED MODULE: ./assets/icons/icon-ps-42.svg
/* harmony default export */ var icon_ps_42 = ({"src":"/_next/static/media/icon-ps-42.a3fc98f0.svg","height":42,"width":124});
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./components/Navbar/Navbar.js














var Navbar = function() {
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(false), open = ref[0], setOpen = ref[1];
    var ref1 = (0,react.useState)(false), stateBanner = ref1[0], setStateBanner = ref1[1];
    var ref2 = (0,react.useState)(false), isOpen = ref2[0], setIsOpen = ref2[1];
    var openModal = function() {
        return setIsOpen(true);
    };
    var closeModal = function() {
        return setIsOpen(false);
    };
    var refModal = (0,react.useRef)();
    (0,react.useEffect)(function() {
        setTimeout(function() {
            if (router.pathname != "/privacy" && router.pathname != "/term") {
                setStateBanner(true);
            }
        }, 800);
    }, [
        router
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
        className: "sticky z-[9] lg:z-[9999] top-0 nav-shadow font-roboto h-[90px] py-[10px] md:h-[118px] bg-white px-[25px] md:px-[120px] md:py-[29px] ",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container relative mx-auto flex flex-row justify-between items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "h-[60px] w-[60px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                layout: "fixed",
                                src: workay_logo/* default */.Z,
                                alt: "_logo"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            onClick: function() {
                                return setOpen(!open);
                            },
                            className: "transition-all cursor-pointer hover:scale-110 active:scale-100 h-[40px] w-[40px] flex flex-col justify-center items-center lg:hidden",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                layout: "fixed",
                                src: burger_icon,
                                alt: "_burger"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "hidden absolute -bottom-[1.91rem] right-0 lg:flex flex-row lg:gap-x-[40px] xl:gap-x-[83px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, {
                                href: "/#section-1",
                                onSetActive: function() {
                                    return setOpen(false);
                                },
                                activeClass: "nav-active",
                                offset: -120,
                                spy: true,
                                smooth: true,
                                to: "section-1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cursor-pointer hover:text-w-green-200",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "pb-1",
                                        children: "Beranda"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, {
                                href: "#section-2",
                                onSetActive: function() {
                                    return setOpen(false);
                                },
                                activeClass: "nav-active",
                                offset: -120,
                                spy: true,
                                smooth: true,
                                to: "section-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cursor-pointer hover:text-w-green-200",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "pb-1",
                                        children: "Mengapa pilih Workay?"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, {
                                href: "#section-3",
                                onSetActive: function() {
                                    return setOpen(false);
                                },
                                activeClass: "nav-active",
                                offset: -120,
                                spy: true,
                                smooth: true,
                                to: "section-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cursor-pointer hover:text-w-green-200",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "pb-1",
                                        children: "Fitur Produk"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, {
                                href: "#section-4",
                                onSetActive: function() {
                                    return setOpen(false);
                                },
                                activeClass: "nav-active",
                                offset: -80,
                                spy: true,
                                smooth: true,
                                to: "section-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cursor-pointer hover:text-w-green-200",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "pb-1",
                                        children: "Gabung Workay"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "hidden mb-4 lg:flex -ml-10 flex-row justify-center items-center gap-x-5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://play.google.com/store/apps/details?id=com.workay",
                                target: "_blank",
                                rel: "noreferrer",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-[100px]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        layout: "responsive",
                                        src: icon_ps,
                                        alt: "_logo"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                onClick: function() {
                                    setOpen(false);
                                    openModal();
                                },
                                className: "bg-w-green-200 rounded-[10px] text-[16px] text-white font-bold py-1 transition-all active:scale-100 focus:outline-none hover:scale-[1.02] px-2",
                                children: "Masuk"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute overflow-hidden transition-all ".concat(open ? "w-5/6" : "w-0", " top-0 right-0 z-[9999] lg:hidden h-screen bg-w-green-200-light"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex h-full flex-col justify-center items-center ".concat(open ? "block" : "hidden"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            onClick: function() {
                                return setOpen(!open);
                            },
                            className: "absolute flex justify-center items-center top-5 right-5 transition-all cursor-pointer hover:scale-110 active:scale-100 h-[40px] w-[40px]",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                layout: "fixed",
                                src: close_icon/* default */.Z,
                                alt: "_logo"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "text-[20px] transition-all ".concat(open ? "-translate-x-0" : "translate-x-[500px]", " text-right w-full px-8 flex flex-col items-center gap-y-8 small-screen:gap-y-14"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "py-5 grid transition-all mb-5 gap-y-3 sms-screen:mb-10 h-full sms-screen:h-[42px] grid-cols-1 sms-screen:grid-cols-2 gap-x-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "https://play.google.com/store/apps/details?id=com.workay",
                                            target: "_blank",
                                            rel: "noreferrer",
                                            className: "w-[124px]",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "w-[124px] h-[42px]",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    layout: "responsive",
                                                    src: icon_png_ps_42,
                                                    alt: "_logo"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "sms-screen:w-[124px] w-full",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                onClick: function() {
                                                    setOpen(false);
                                                    openModal();
                                                },
                                                className: "bg-w-green-200 h-[42px] w-[124px] rounded-[10px] text-[16px] text-white font-bold transition-all active:scale-100 focus:outline-none hover:scale-[1.02] px-4",
                                                children: "Masuk"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "w-full px-5 flex flex-col gap-y-8 small-screen:gap-y-14",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, {
                                            href: "#section-1",
                                            onSetActive: function() {
                                                return setOpen(false);
                                            },
                                            activeClass: "nav-side-active",
                                            offset: -120,
                                            spy: true,
                                            smooth: true,
                                            to: "section-1",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "cursor-pointer hover:text-w-green-200",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "pb-1",
                                                    children: "Beranda"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                            className: "nav-hr"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, {
                                            href: "#section-2",
                                            onSetActive: function() {
                                                return setOpen(false);
                                            },
                                            activeClass: "nav-side-active",
                                            offset: -100,
                                            spy: true,
                                            smooth: true,
                                            to: "section-2",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "cursor-pointer hover:text-w-green-200",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: "Mengapa pilih Workay?"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                            className: "nav-hr"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, {
                                            href: "#section-3",
                                            onSetActive: function() {
                                                return setOpen(false);
                                            },
                                            activeClass: "nav-side-active",
                                            offset: -100,
                                            spy: true,
                                            smooth: true,
                                            to: "section-3",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "cursor-pointer hover:text-w-green-200",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "pb-1",
                                                    children: "Fitur Produk"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                            className: "nav-hr"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(modules/* Link */.rU, {
                                            href: "#section-4",
                                            onSetActive: function() {
                                                return setOpen(false);
                                            },
                                            activeClass: "nav-side-active",
                                            offset: -50,
                                            spy: true,
                                            smooth: true,
                                            to: "section-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "cursor-pointer hover:text-w-green-200",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "pb-1",
                                                    children: "Gabung Workay"
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat(stateBanner ? "" : "translate-y-40", " transition-all duration-[400ms] fixed bottom-0 left-0 right-0 pt-5  bg-white flex lg:hidden flex-col items-center"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        onClick: function() {
                            setTimeout(function() {
                                setStateBanner(false);
                            }, 500);
                        },
                        className: "absolute flex justify-center items-center top-2 right-5 transition-all cursor-pointer hover:scale-110 active:scale-100 h-[40px] w-[40px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            layout: "fixed",
                            src: close_icon/* default */.Z,
                            alt: "_logo"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "py-5 grid transition-all mb-5 sms-screen:mb-10 h-full sms-screen:h-[42px] grid-cols-1 sms-screen:grid-cols-2 gap-x-3 gap-y-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "https://play.google.com/store/apps/details?id=com.workay",
                                target: "_blank",
                                rel: "noreferrer",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "w-full",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        layout: "responsive",
                                        src: icon_png_ps_42,
                                        alt: "_logo"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "sms-screen:w-[124px] w-full",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    onClick: function() {
                                        setOpen(false);
                                        openModal();
                                    },
                                    className: "bg-w-green-200 h-[42px] w-[124px] rounded-[10px] text-[16px] text-white font-bold transition-all active:scale-100 focus:outline-none hover:scale-[1.02] px-4",
                                    children: "Masuk"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                appear: true,
                show: isOpen,
                as: react.Fragment,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dialog/* Dialog */.V, {
                    initialFocus: refModal,
                    as: "div",
                    className: "relative z-[9999]",
                    onClose: closeModal,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
                            as: react.Fragment,
                            enter: "ease-out duration-300",
                            enterFrom: "opacity-0",
                            enterTo: "opacity-100",
                            leave: "ease-in duration-200",
                            leaveFrom: "opacity-100",
                            leaveTo: "opacity-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "fixed inset-0 bg-black bg-opacity-25"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "fixed inset-0 overflow-y-auto",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex min-h-full items-center justify-center p-5 text-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition.Child */.u.Child, {
                                    as: react.Fragment,
                                    enter: "ease-out duration-300",
                                    enterFrom: "opacity-0 scale-95",
                                    enterTo: "opacity-100 scale-100",
                                    leave: "ease-in duration-200",
                                    leaveFrom: "opacity-100 scale-100",
                                    leaveTo: "opacity-0 scale-95",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog/* Dialog.Panel */.V.Panel, {
                                        className: "w-full font-roboto py-[130px] sm:py-[130px] max-w-3xl transform overflow-hidden rounded-[15px] bg-white p-6 text-left align-middle shadow-xl transition-all",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex gap-x-[60px] flex-col justify-center items-center",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    onClick: closeModal,
                                                    className: "w-[42px] h-[42px] flex hover:scale-110 active:scale-100 justify-center items-center absolute top-5 right-5",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: close_icon/* default */.Z,
                                                        alt: "close-icon"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "absolute bottom-0 left-0 right-0 pt-5 pb-5  bg-w-green-200 flex flex-col items-center",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "text-white font-roboto items-center flex flex-col sm:flex-row gap-x-3 gap-y-2",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                children: [
                                                                    "Dapatkan aplikasi ",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                        children: "Workay di"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                href: "https://play.google.com/store/apps/details?id=com.workay",
                                                                target: "_blank",
                                                                rel: "noreferrer",
                                                                className: "w-[103px]",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "w-[103px]",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                        layout: "responsive",
                                                                        src: icon_ps,
                                                                        alt: "_logo"
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                        className: "font-bold text-center text-[32px] text-w-text",
                                                        children: "Anda ingin masuk sebagai:"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "mt-10 flex flex-col items-center gap-y-5 w-full",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "https://web.workay.id",
                                                            target: "_blank",
                                                            rel: "noreferrer",
                                                            className: "bg-w-green-200 text-center w-[201px] rounded-[10px] text-[16px] text-white font-bold py-3 transition-all active:scale-100 focus:outline-none hover:scale-[1.02] px-4",
                                                            children: "Karyawan"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            href: "https://hr.workay.id",
                                                            target: "_blank",
                                                            rel: "noreferrer",
                                                            className: "w-[201px] rounded-[10px] hover:bg-w-green-100 active:bg-w-green-100 text-center text-[16px] text-w-green-200 font-bold py-3 transition-all active:scale-100 focus:outline-none hover:scale-[1.02] px-4",
                                                            children: "Tim HRD"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Navbar_Navbar = (Navbar);


/***/ })

}]);